/**
 * created by hezq on 2019-09-09
 *
 * description： 每个需要登录的页面都要处理的公共部分
 *
 */

import utils from 'libs/utils.js';
import http from 'libs/http.js';
import Cookies from 'js-cookie';
import api from 'api';
import consts from 'consts';

const config = require('libs/config.js');

export default class PageInit {
	/**
	 * description： 构造函数
	 * @param {Object} 属性集合
	 *
	 * created by hezq on 2019-09-09
	 *
	 */
	constructor(options) {
		options = options || {};

		// 获取token
		this.token = Cookies.get(config.PLAT + config.DOMAIN + '.access_token', {
			domain: config.DOMAIN
		}) || null;

		// 获取userid
		this.userid = Cookies.get(config.PLAT + config.DOMAIN + '.userid', {
			domain: config.DOMAIN
		}) || null;

		// 如果有一个获取不到，清除本地缓存
		if (this.token == null || this.userid == null) {
			// 清除user信息
			tools.store.delSS('user');
			// 跳转到登录页
			window.location.href = config.BS_PATH;
		}

		// 当前对应平台
		this.sid = '';
		// 所有平台
		this.plats = [];
	}

	/**
	 * description： 接口初始化
	 *
	 * created by hezq on 2019-09-10
	 *
	 */
	async APIInit() {
		if (this.token) {
			// 清除定时
			if (this.st) {
				clearTimeout(this.st);
			}

			// 1分钟后刷新token
			this.st = setTimeout(() => {
				this.refreshToken();
			}, 60 * 1000);

			await Promise.all([(async () => {
				await this.getUser();
				await this.getQxs();
			})(), await this.getPlats()]);
			await this.getCheckCode();
			
			// return new Promise((resolve, reject) => {
			// 	this.getUser().then(() => {
			// 		this.getQxs().then(() => {
			// 			this.getCheckCode().then(() => {
			// 				resolve();
			// 			});
			// 		}).catch(() => {
			// 			reject();
			// 		});
			// 	}).catch(() => {
			// 		reject();
			// 	});
			// });
		}
		
		this.webFunnyReport()
	}
	
		/**
		 * description: webFunny数据上报
		 *
		 * created by hezq on 2023-07-20 15:46:37
		 *
		 */
		webFunnyReport() {
			const userId = this.user ? (this.user.userid || '') : 'visitor'
			const hydm = this.user ? (this.user.hydm || '') : '0000'
			window.localStorage.wmUserInfo = JSON.stringify({ userId: userId, userTag: hydm, projectVersion: "审批服务-前台",
				env: "pro" })
		}
		
	/**
	 * description： 获取用户信息
	 *
	 * created by hezq on 2019-09-09
	 *
	 */
	getUser() {
		return new Promise((resolve, reject) => {
			let user = tools.store.getLS('user', true);

			if (user == null || user.userid !== this.userid) {
				let params = {
					url: api.common.getUserInfo
				};

				http.ajax(params, (res) => {
					this.user = res.mboptDTO;
					// 存在用户信息到本地缓存
					tools.store.setLS('user', res.mboptDTO);
					// 返回
					resolve();
				}, err => {
					this.user = {};
					// 拦截
					reject();
				});
			} else {
				this.user = user;
				resolve();
			}

		}).catch(() => {

		});
	}

	/**
	 * description： 获取权限
	 *
	 * created by hezq on 2019-09-26
	 *
	 */
	getQxs() {
		return new Promise((resolve, reject) => {

			// 请求参数
			let params = {
				url: api.common.getQxs(config.SSID),
				data: {
					optid: this.userid,
					// gid: gid,
				}
			};

			// 远程调用
			http.ajax(params, res => {
				// 防空判断
				res.data = res.data || [];

				// 组装工作台需要的权限数据
				let dataTmp = tools.clone(res.data);

				dataTmp = dataTmp.filter(item => item.url === 'menu');

				let authTmp = [];

				if (dataTmp.length > 0 && dataTmp[0].listAuthDtos) {
					dataTmp[0].listAuthDtos.forEach(item => {
						// 去掉括号里的部分
						authTmp.push(item.mkname.replace(/\uff08.*?\uff09$/g, ''));
					});
				}
				// 挂载到实例属性
				this.workBentchAuths = authTmp;

				let btnAuths = {};
				// 组装权限数据

				res.data.forEach(mk => {
					if (mk.listAuthDtos && mk.listAuthDtos.length) {
						mk.listAuthDtos.forEach(mx => {
							btnAuths[mx.mkid] = true;
							if (mx.sonAuthDtos && mx.sonAuthDtos.length) {
								mx.sonAuthDtos.forEach(btn => {
									btnAuths[btn.mkid] = true;
								});
							}
						});
					}
				});

				// 挂载到实例属性
				this.btnAuths = btnAuths;
				tools.store.setLS('btnAuths', btnAuths);

				resolve();

			}, err => {
				reject();
			});
			// resolve();
		});

	}

	/**
	 * description： 1分钟刷新token
	 *
	 * created by hezq on 2019-09-09
	 *
	 */
	refreshToken() {
		// 清除轮询
		if (this.sst) {
			clearInterval(this.sst);
		}

		//1分钟一次刷新token
		this.sst = setInterval(() => {
			const refreshToken = Cookies.get(config.PLAT + config.DOMAIN + '.refresh_token', {
				domain: config.DOMAIN
			})

			let params = {
				url: api.common.refreshToken,
				data: {
					refresh_token: refreshToken
				},
				type: 'POST'
			};

			http.ajax(params, (res) => {
				// 更新cookie
				utils.refresh(res)
			});

		}, 60 * 1000);
	}

	/**
	 * description: 获取审批对象
	 *
	 * created by zhouzt on 2019-10-30
	 *
	 */
	getCheckCode() {
		// 请求参数
		let params = {
			url: api.common.getCheckCode,
			data: {
				sid: this.sid,
				page: 0,
				size: 0
			}
		};

		// 远程调用
		return new Promise((resolve, reject) => {
			http.ajax(params, res => {
				this.checkCodes = res.data;
				resolve(res);
			}, err => {
				this.checkCodes = {};
				reject(err);
			});
		});
	}

	/**
	 * description: 获取平台数据
	 *
	 * created by zhouzt on 2020-05-25
	 *
	 */
	getPlats() {
		// 远程调用
		return new Promise((resolve, reject) => {
			// 请求参数
			let params = {
				url: api.common.getBusinessList,
				data: {
					businessTypeEnum: 'PLATFORM'
				}
			};

			// 远程调用
			http.ajax(params, res => {
				res.forEach(item => {
					item.name = item.sname
					delete item.sname
				})

				this.plats = res
				if (this.plats.length > 0) {
					this.sid = this.plats[0].sid;
				}
				this.getSid();
				resolve()
			}, err => {
				reject(err);
			});

		});
	}

	/**
	 * description: 获取 sid
	 *
	 * created by zhouzt on 2020-06-04
	 *
	 */
	getSid() {
		if (utils.getUrlParams()[Base64.encodeURI('sid')]) {
			this.sid = Base64.decode(utils.getUrlParams()[Base64.encodeURI('sid')]);
			tools.store.delSS(consts.STORE.PLATSTORE);
			tools.store.setSS(consts.STORE.PLATSTORE, this.sid);
		} else if (tools.store.getSS(consts.STORE.PLATSTORE)) {
			this.sid = tools.store.getSS(consts.STORE.PLATSTORE);
		}
	}
}



// WEBPACK FOOTER //
// ./src/libs/init.js